/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */

export type UnitEnum = (typeof UnitEnum)[keyof typeof UnitEnum];

export const UnitEnum = {
  kg: 'kg',
  lbs: 'lbs',
} as const;
